var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticStyle:{"margin-top":"5%","margin-left":"5%","font-weight":"bold","font-size":"xxx-large"}},[_vm._v("敬请期待…")])])}]

export { render, staticRenderFns }